import axios from "axios";

const api = axios.create({
  baseURL: "https://election.mgmebuild.com/api/",
});

// Automatically attach access token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
